import useMetabaseUrl from "../../../hooks/useMetabaseUrl";
import DashboardPlaceholder from "./DashboardPlaceholder";

const MetabaseDashboard = ({
  url,
  parameters = {},
  hideList = [],
  showDashboard = false,
}) => {
  const dashboardUrl = useMetabaseUrl({
    url,
    parameters,
    hideList,
  });

  console.log(dashboardUrl);

  return (
    <>
      {showDashboard ? (
        <div className="iframe-wrapper">
          <iframe src={dashboardUrl}></iframe>
        </div>
      ) : (
        <DashboardPlaceholder />
      )}
    </>
  );
};

export default MetabaseDashboard;
